<template>
  <div class="main">
    <div class="title-container">
      <h2>Subida de archivos</h2>
    </div>
    <div class="upload-files-container">
      <div v-for="(fileToUpload, index) in numberOfFilesToUpload" v-bind:key="index">
        <upload-file :fileType="fileToUpload.fileType" />
      </div>
    </div>
  </div>
</template>

<script>
import { EventDriver } from '../utils/EventDriver';
import UploadFile from '../components/UploadFileBucket.vue'
export default {
  name: "UploadFiles",
  components: {
    UploadFile
  },
  data() {
    return {
      numberOfFilesToUpload: [
        { fileType: 'Cédula Contable' },
        { fileType: 'Cédula Operativa' },
        { fileType: 'Cédula Financiera' },
        { fileType: 'Cédula Producción' },
        { fileType: 'Finanzas CEE' },
        { fileType: 'FMP49 Licencias' },
        { fileType: 'FMP50 Licencias' },
        { fileType: 'FMP53' },
        { fileType: 'FMP54' },
        { fileType: 'Producción CEE' },
        { fileType: 'Sipac CEE' }
      ]
    }
  },
  methods: {
    logOut() {
      EventDriver.$emit('logOut');
    },
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box !important;
}
.main {
  margin: 0;
  width: 100%;
  height: 100%;
  background: #E5E5E5;
  padding: 0 1% 1% 1%;
}
.upload-files-container {
  width: 100%;
  height: 92%;
  display: grid;
  margin: 0 0 0 0;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto;
  row-gap: 10px;
  column-gap: 10px;
  justify-items: center; 
  padding: 20px 20px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  justify-items: stretch;
  align-items: stretch;
  background: #FAFAFA;
  border-radius: 10px;
}
.title-container {
  text-align: start;
  padding: 15px 0;
  height: 8%;
}
@media only screen and (max-width: 1400px) {
  .upload-files-container {
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 20px;
    padding: 5px 5px;
    column-gap: 20px;
    height: auto;
  }
  .title-container {
  text-align: start;
  padding: 5px 0 5px 0;
  height: auto;
}
}
</style>
